import * as React from 'react';

import { Button, useDeviceType } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsStickyScrollBtnVisible } from '../../selectors/page';
import { setModalFormOpen } from '../../slices';
import { StickyFooter } from '../../components/StickyFooter';
import { trackCtaClick } from './tracking';

export const StickyFooterContainer: React.FC = () => {
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const isStickyBtnVisible = useSelector(selectIsStickyScrollBtnVisible);

  const handleModalOpenClick = React.useCallback(
    (source: 'consultation' | 'ticket') => {
      trackCtaClick(source);
      dispatch(setModalFormOpen(source));
    },
    [dispatch],
  );

  if (!isStickyBtnVisible) {
    return null;
  }

  return (
    <StickyFooter
      title="Не тратьте время — доверьтесь профи"
      isDesktop={isDesktop}
      primaryButton={
        <Button
          theme="fill_primary"
          size={isDesktop ? 'L' : 'M'}
          onClick={() => {
            handleModalOpenClick('ticket');
          }}
          fullWidth={!isDesktop}
        >
          Оставить заявку
        </Button>
      }
      secondaryButton={
        <Button
          theme="fill_secondary"
          size={isDesktop ? 'L' : 'M'}
          onClick={() => {
            handleModalOpenClick('consultation');
          }}
          fullWidth={!isDesktop}
        >
          Получить консультацию
        </Button>
      }
    />
  );
};
